import { render, staticRenderFns } from "./ColdWalletSetting.vue?vue&type=template&id=0f0bd8db&scoped=true"
import script from "./ColdWalletSetting.vue?vue&type=script&lang=js"
export * from "./ColdWalletSetting.vue?vue&type=script&lang=js"
import style0 from "./ColdWalletSetting.vue?vue&type=style&index=0&id=0f0bd8db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0bd8db",
  null
  
)

export default component.exports